<template>
  <div class="about-images-component">
    <div class="container px-4">
      <div class="row">
        <div class="col-12">
          <img src="../../assets/images/about/about_img1.png" class="img-fluid" alt="Chocolate balls">
        </div>
      </div>
      <div class="mt-5"></div>
      <div class="row">
        <div class="col-6">
          <img src="../../assets/images/about/about_img2.png" class="img-fluid" alt="Chocolate balls">
        </div>
        <div class="col-6">
          <img src="../../assets/images/about/about_img3.png" class="img-fluid" alt="Chocolate balls">
        </div>
      </div>
      <div class="mb-5"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About_Images"
};
</script>

<style lang="sass" scoped>
  .img-fluid
    width: 100%
</style>
